<template>
  <!-- 音频播放器组件 同时包含了图片的显示 -->
  <div class="hello">
    <div v-if="ifHide == 0">
      <div v-if="imgSrc!=''" class="listenboxwide">
        <div class="listenbox">
          <img style="width:100%;height:100%;" :src="imgSrc" />
        </div>
      </div>
      <div>
        <span class="hideProgress">播放进度条:</span>
        <el-progress :text-inside="true" :stroke-width="12" :percentage="playProgress"></el-progress>
      </div>
      <br>
    </div>
    <div class="volume">
      <div class="volumeAdd">
        <!--<span class="hideProgress">音量条</span>-->
        <!--<el-progress :text-inside="true" :stroke-width="12" :percentage="volume"></el-progress>-->
        <!--<el-button class="reduce" icon="el-icon-minus" @click="decrease"></el-button>-->
        <!--<el-button class="add" icon="el-icon-plus" @click="increase"></el-button>-->

        <div class="volbox">
          <div class="volpanel">
            <span class="minus" @click="decrease">-</span>
            <span class="volitem">
              <span v-for="(item,index) in volumeInfo" :key="index" :class="item == 0?'itact':'it'"></span>
            </span>
            <span class="plus" @click="increase">+</span>
          </div>
        </div>
      </div>
    </div>
    <div style="text-align: center">
      <!-- 根据是否 -->
      <audio  ref="audio" :src="src" :controls="controls" :autoplay="autoplay"
              :volume="volume/100"
              @timeupdate="updateTime"
              @canplay="getDuration"
              @ended="endTime"
              controlsList="nodownload"
      ></audio>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AudioPlay',
  props: {
    srcInfo: {
      type:Object,
      default:null
    },
    ifHide:{
      type:Number,
      default:0
    }
  },
  data() {
    return {
      src:null,
      imgSrc:"",
      //当前的播放时长
      currentTime:0,
      //音频总时长
      duration:0,
      //当前的播放百分比
      playProgress:0,
      //是否显示播放控件
      controls:false,
      autoplay:true,
      //音量大小
      volume:100,
      volumeInfo:[0,0,0,0,0,0,0,0,0,0],

    };
  },
  created() {
    if(this.srcInfo && this.srcInfo.defaultImg && this.srcInfo.defaultImg.length > 0) {
      this.imgSrc = this.GLOBAL.getFileServeUrl()+this.srcInfo.defaultImg[0].downAddress;
    }
    //根据是否拖动进度条 进行控件显示隐藏的设置
    if(this.srcInfo.ifDragPlay && this.srcInfo.ifDragPlay == 1) {
      this.controls = true;
    }
    this.autoplay = (this.srcInfo.ifAutoPlay&&this.srcInfo.ifAutoPlay!=1?false:true);
    console.log("this.srcInfo=================",this.srcInfo);
    this.src = this.GLOBAL.getFileServeUrl()+this.srcInfo.downAddress;
  },
  mounted() {
   console.log(this.volume);
  },
  watch:{
     //播放时 进行播放的百分比计算
    currentTime: function(val){
      this.playProgress = ((val/this.duration)*100).toFixed(0)*1;
    }
  },
  computed:{
  },
  components: {
  },
  methods: {
    getDuration() {
      var that = this;
      console.log("duration=================",this.$refs); //此时可以获取到duration
      this.duration = this.$refs.audio.duration;
      setTimeout(function () {
        that.play();
      }, 1000);
    },
    play(){
      if(this.autoplay) {
        this.$nextTick(function(){
          this.$refs.audio.play();
        });
      }
    },
    /**
     * 播放时长改变时 记录当前的播放时间
     */
    updateTime(e) {
      this.currentTime = e.target.currentTime;  //获取audio当前播放时间
      //console.log("this.currentTime=========",this.currentTime);
      //根据播放时长 判断显示哪个背景图片
      if(this.srcInfo.imgArr) {
        this.srcInfo.imgArr.forEach(element => {
          var showTime = element.showTime;
          if(showTime) {
            var startMiao = 0;
            var endMiao = 0;
            if(!element.startMiao || !element.endMiao) {
              if(showTime.indexOf("-")>0) {
                var startTime = showTime.split("-")[0];
                var endTime = showTime.split("-")[1];
                
                if(startTime) {
                  var startMinute = startTime.split(":")[0];
                  var startS = startTime.split(":")[1];
                  startMiao = startMinute*60+startS*1;
                }
                element.startMiao = startMiao;
                
                if(endTime) {
                  var endMinute = endTime.split(":")[0];
                  var endS = endTime.split(":")[1];
                  endMiao = endMinute*60+endS*1;
                }
                element.endMiao = endMiao;
              }
            } else {
              startMiao = element.startMiao;
              endMiao = element.endMiao;
            }
            if(this.currentTime >= startMiao && this.currentTime <= endMiao) {
              if(element.defaultImg && element.defaultImg.length > 0) {
                this.imgSrc = this.GLOBAL.getFileServeUrl()+element.defaultImg[0].downAddress; 
              }
            } else {
              if(this.srcInfo.defaultImg && this.srcInfo.defaultImg.length > 0) {
                this.imgSrc = this.GLOBAL.getFileServeUrl()+this.srcInfo.defaultImg[0].downAddress;
              }
            }
          }
        });
      }
    },
    /**
     * 播放结束后的事件
     */
    endTime(){
      //调用传递进来的播放事件
      this.$emit("endTime");
    },
    //增加音量
    increase() {
      this.volume += 10
      if(this.volume > 100){
        this.volume = 100
        return
      }
      console.log('增加',this.volume/100);
      this.$refs.audio.volume = this.volume/100;
      var a = this.volume/10-1
      this.volumeInfo[a] = 0


    },
    //降低音量
    decrease() {
      this.volume -= 10;
      if(this.volume <0){
        this.volume = 0
        return
      }
      console.log('降低',this.volume/100);
      this.$refs.audio.volume = this.volume/100;
      var a = this.volume/10
      this.volumeInfo[a] = 1

    }

  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import './css/switchStyle.less';

  .listenboxwide {margin: 20px 0 20px 0;text-align: center;line-height: normal;  }
  .listenbox {width: 450px;height: 350px;margin: 0 auto;background: #FFFBF7;border: 2px solid #666;font-size: 25px;text-align: center;}

  .playerpositionbox {width: 302px;margin: 0 auto;border: 1px solid #000;padding: 8px 8px;background: #C0C0C0;}
  .volumeAdd .el-button{padding: 9.5px 20px !important;}

  .hello .el-progress-bar__innerText{font-size: 10px;margin: 0 5px 5px;}


  .volitem {
    margin: 0;
    padding: 0;
  }
  .volitem span {
    display: inline-block;
    height: 8px;
    width: 6px;
    margin-bottom: 3px;
  }
  .itact {
    background: #99CCFF;
    border: 1px solid #336699;
  }
  .it{
    background: #336699;
    border: 1px solid #336699;
  }
  .volbox {
    width: 200px;
    margin: 0 auto;
    background: #fff;
    border: 1px solid #394D94;
    padding: 1px 0px 1px 0px;
    text-align: center;
  }
  .volpanel .minus, .volpanel .plus {
    border: 1px solid #666;
    background: #ccc;
    width: 15px;
    height: 12px;
    line-height: 8px;
    cursor: pointer;
    font-size: 12px;
  }
  .volpanel .minus:hover, .volpanel .plus:hover {
    background: #394D94;
    color: #fff;

  }
  .volpanel span {
    display: inline-block;
    margin-right: 5px;
  }
</style>
